module.exports = __webpack_public_path__ + "static/fostercity-e45236ffb201e33334c313f13a21503d.jpg";